import { APP_URLS } from '../../consts';
import { BRANDS } from '../../components/Itv/types';

const ITV_ROOT_SEGMENT = APP_URLS.itv.root.replace(/^\//, '');
const SUPPORTED_ITV_BRANDS: BRANDS[] = [BRANDS.BINGO, BRANDS.SPINS];

const isSupportedItvBrand = (value: string | undefined): value is BRANDS => {
  return Boolean(value && SUPPORTED_ITV_BRANDS.includes(value as BRANDS));
};

export const buildItvGameDetailsBasePath = (brand: BRANDS): string => {
  return `${APP_URLS.itv.root}/${brand}/game-details`;
};

export const resolveGameDetailsBasePath = (
  pathname: string
): {
  basePath: string;
  brand: BRANDS | null;
} => {
  const normalizedPath = pathname.split('?')[0];
  const segments = normalizedPath.split('/').filter(Boolean);
  const [, brandSegment] = segments[0] === ITV_ROOT_SEGMENT ? segments : [];

  if (isSupportedItvBrand(brandSegment)) {
    return {
      basePath: buildItvGameDetailsBasePath(brandSegment),
      brand: brandSegment,
    };
  }

  return {
    basePath: APP_URLS.gameDetailsBase,
    brand: null,
  };
};

export type GameDetailsBasePathResult = ReturnType<typeof resolveGameDetailsBasePath>;
